import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddMileStone from "./AddMileStone";
import { toast } from "react-toastify";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";

const MileStone = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10;
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getLeadershipCouncils();
  }, []);
  const getLeadershipCouncils = () => {
    WebService.getAPI({
      action: `milestone-awards/list`,
    })
      .then((res: any) => {
        // Access the right array level
           const perm = res?.data?.permissions || {};

        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const list = res?.data?.data || [];
    
        // Format each milestone entry
        const formattedRows = list.map((item: any) => ({
          ...item,
          year: item.year,
          // show the title of the first description only
          designation:
            item?.description?.length > 0 ? item.description[0].title : "-",
          action: (
            <div>
                         {perm.canEdit && (
              <PencilFill
                className="me-3 cursor-pointer"
                onClick={() => {
                  setShowAddLeadershipCouncil(true);
                  setLeadershipCouncilToEdit(item);
                }}
                title="Edit"
              /> )}
                  {perm.canDelete && (
              <TrashFill
                color="#DC143C"
                className="cursor-pointer"
                onClick={() => handleDeleteEvent(item._id)}
                title="Delete"
              /> )}
            </div>
          ),
        }));

        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.data?.pagination?.total || 0);
      })
      .catch((err: any) => {
        console.error("Error fetching milestones:", err);
      });
  };
  const handleReorder = (newRows: any) => {
    setLeadershipCouncils(newRows);

    const reorderedPayload = newRows.map((item: any, index: number) => ({
      _id: item._id,
      order_by: index + 1,
    }));

    WebService.postAPI({
      action: "milestone-awards/update-order",
      body: reorderedPayload,
    })
      .then(() => {})
      .catch(() => {
        toast.error("Failed to update order");
      });
  };
  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddMileStone
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getLeadershipCouncils();
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `milestone-awards/delete-milestone/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getLeadershipCouncils();
            });
          }
        }}
        message="Are you sure you want to delete this milestones & achivements?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Milestones and Achivements</div>
              {pagePermission.canAdd && (
            <CustomButton
              isLoading={false}
              label="Add"
              onClick={() => {
                setLeadershipCouncilToEdit(null);
                setShowAddLeadershipCouncil(true);
              }}
              style={{ width: 100 }}
            /> )}
          </div>
          <CustomTableSortable
            columns={[
              { id: "year", label: "Year", minWidth: 170 },
              {
                id: "designation",
                label: "Description",
                minWidth: 100,
                align: "left",
              },

              { id: "action", label: "Action", minWidth: 100, align: "center" },
            ]}
            rows={leadershipCouncils}
            totalCount={0}
            currentPage={1}
            pageSize={10}
            onPageChange={() => { }}
            draggable // 👈 enable drag
            onRowsReorder={handleReorder} // 👈 handle dropping
            pagination={false}
          />
        </Card>
      </div>
    </>
  );
};

export default MileStone;
